import React, { useState } from "react";
import { ThemMoi } from "./ThemMoi";

export const AddTaiKhoanDesktopBtn = (data) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  }

  return (
    <div className="iconbutton-new hidden-mobile-main show-table-main">
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <button
            type="button"
            className="btn btn-border-new"
            onClick={handleShow}
          >
            <i className="mdi mdi-plus"></i> Thêm mới
          </button>
        </div>
      </div>
      {show && <ThemMoi data = {data} show={show} onHide={handleClose} />}
    </div>
  );
};
